// extracted by mini-css-extract-plugin
module.exports = {"noShippingPrice":"_3db0bd39"};